import { Injectable } from '@angular/core';
import {
  STOCKCART,
  AdpCustomer,
  attributesMap,
  attributesPropertiesMap,
  RECEIVESTOCKLOCATION, REFERENCE
} from '../providers/data';
import {IMAGES_BASE_URL} from './config';

import { Storage } from '@ionic/storage';


import {DomSanitizer} from '@angular/platform-browser';
import moment from "moment";
@Injectable()
export class StockcartManager {



public getCust:any ;
constructor(private storage:Storage,private sanitizer:DomSanitizer){

}



setCustomer(customer){

  if(STOCKCART.customer == null){

  STOCKCART.customer = customer;
  }else{
    this.clearCartProducts();
    STOCKCART.customer = customer;
  }
}

setReference(reference){
  REFERENCE.productsreference = reference;
}

setLocation(location){
  RECEIVESTOCKLOCATION.productsLocation = location;
}

  setSupplier(supplier){
    RECEIVESTOCKLOCATION.supplier = supplier;
  }

// setSalesPerson(user){
//   STOCKCART.user = user;
// }

clearCart(){
  STOCKCART.items = [];
}


addToCartNew(product) {
    if(!Number(product.quantity)){
        // if(Number(product.quantity)<=1){
          product.quantity = 0;
        // }
      }

      STOCKCART.items.push(product);
      this.persistOrderLocal();

// }
}
addProductToCart(product) {
    if(product.productType === 1){
      product.lotNumber = "111"
    }
     var index= STOCKCART.items.map(function(x) {return x.id; }).indexOf(product.id);
      if (index != -1) {
          STOCKCART.items[index].quantity++;
          this.persistOrderLocal();
      } else {
          if (Number(product.quantity) != 0) {
            product.quantity = Number(product.quantity);
          } else {
            product.quantity = 0;
          }
          this.addToCartNew(product);
      }
      //alert(JSON.stringify(STOCKCART));
  }

  getProductsLengthInsideCart(){
    return STOCKCART.items.length;
  }

  addProductToCartFromPopUp(product) {

  console.log("prorrrrrrrrrrrrrrrr " + product)
    var index= STOCKCART.items.map(function(x) {return x.id; }).indexOf(product.id);
    if (index != -1) {

      if(product.productType === 0){
        STOCKCART.items[index].quantity = product.quantity;
      }else {
        STOCKCART.items[index].quantity++;
      }
      this.persistOrderLocal();
    } else {
      if (Number(product.quantity) != 0) {
        product.quantity = Number(product.quantity);
      } else {
        product.quantity = 0;
      }
      this.addToCartNew(product);
    }
    //alert(JSON.stringify(STOCKCART));
  }


  getQuantityIfProductAlreadyAdded(product) {
    var index= STOCKCART.items.map(function(x) {return x.id; }).indexOf(product.id);
    if (index != -1) {
      return STOCKCART.items[index].quantity;
    } else {
      return null;
    }
    //alert(JSON.stringify(STOCKCART));
  }

  addProductToCartPopup(product) {

      product.quantity++;
      this.persistOrderLocal();
    // } else {
      if (Number(product.quantity) != 0) {
        product.quantity = Number(product.quantity);
      } else {
        product.quantity = 0;
      }
  }

  // update Cart
  updateCartNew(product) {
    if(Number(product.quantity) < Number(product.minOrder)){
      if (Number(product.minOrder) != 0) {
        if (Number(product.quantity) != 0) {
          product.quantity = Number(product.quantity);
        }
      }
    }


     var index= STOCKCART.items.map(function(x) {return x.id; }).indexOf(product.id);
      if (index != -1) {
      } else {

          this.addToCartNew(product);
      }
      this.persistOrderLocal();
  }

  updateCartNewPopup(product) {


    if(Number(product.quantity) < Number(product.minOrder)){
      if (Number(product.minOrder) != 0) {
        if (Number(product.quantity) != 0) {
          product.quantity = Number(product.quantity);
        }
      }
    }


    var index= STOCKCART.items.map(function(x) {return x.id; }).indexOf(product.id);
    if (index != -1) {
    } else {
    }
    this.persistOrderLocal();
  }
  // Remove One
  removeOneNew(product) {

    product.quantity--;

  }

  // removeOneNewPopup(product) {
  //   var index= STOCKCART.items.map(function(x) {return x.id; }).indexOf(product.id);
  //   if (index != -1) {
  //     // if(STOCKCART.items[index].quantity > Number(product.minOrder)){
  //     STOCKCART.items[index].quantity--;
  //     this.persistOrderLocal();
  //
  //
  //   }
  // }

  // Remove All
  removeAll(product) {
    var index= STOCKCART.items.map(function(x) {return x.id; }).indexOf(product.id);
      if (index != -1) {
        if(STOCKCART.items[index].quantity >= 1){
          STOCKCART.items[index].quantity = 0;
        }
        }
        this.persistOrderLocal();
      }


  // Remove Item
  removeNew(index: number): void {

    STOCKCART.items.splice(index, 1);
    this.persistOrderLocal();
  }

  deleteProductFromCart(product){
    this.removeAll(product);
    var index= STOCKCART.items.map(function(x) {return x.id; }).indexOf(product.id);
      if (index != -1) {
        this.removeNew(index);
      }
  }

  genrateOrder(status){
    //alert(JSON.stringify(STOCKCART));
   let total = 0;
  let orderProducts = [];
  let expectedShipmentDate = STOCKCART.shipDate;
  for(let item of STOCKCART.items){

    if(this.discountCheck(item.discountPrice)){
       total =  total + (Number(item.discountPrice) * Number(item.quantity));
     }else{
     total =  total + (Number(item.price) * Number(item.quantity));
     }

    var orderDetailDTOs: any = {

       "productsDTO":item,
       "quantity": item.quantity,
       "expectedShipmentDate": expectedShipmentDate,
       "attributeSearch":item.attributeSearch
     };

     orderProducts.push(orderDetailDTOs);
  }

  if(STOCKCART.customer.locationsDTOs.length>0){
    for(let locationId in STOCKCART.customer.locationsDTO){
      STOCKCART.customer.locationsDTO[locationId].createdAt = "";
      STOCKCART.customer.locationsDTO[locationId].updatedAt = "";
    }
  }

  STOCKCART.customer.customerJson = "";

  let order = {
    "id":STOCKCART.orderId,
    "orderTitle": this.getOrderTitle(),
    "salesManId":STOCKCART.user.id,
    "orderMessage":STOCKCART.orderMessage,
    "expectedShipmentDate": STOCKCART.expectedShipmentDate,
    "totalAmount":""+total.toFixed(2),
    "totalTexAmount":"10",
    "orderStatus":status,
    "customerDTO":STOCKCART.customer,
    "orderDetailDTOs": orderProducts,
    "shippingServiceName":STOCKCART.shippingServiceName,
    "shippingServiceValue":STOCKCART.shippingServiceId
        };
        return order;

  }

  receiveStock(status, reference, productLocation, supplierName){
    // alert("product warehouse id " + warehouseId);
   let total = 0;
  let orderProducts = [];
  let expectedShipmentDate = STOCKCART.shipDate;

      const date = moment().format("YYYY-MM-DD");
  for(let item of STOCKCART.items){

    console.log("BBBBBBBBBBBBBBBBBBBBBBB " + item.badProductDtoList);
    if(item.badProductDtoList !== undefined){
      let total = 0;
      for(let badPro of item.badProductDtoList){
        total += badPro.quantity;
        if(badPro.comment !== null && badPro.comment !== ""){
          this.storage.get("userName").then((data) =>{
            badPro.comment = btoa(data  + "(" +  date +")" + ": " + badPro.comment);
          })
        }
      }
      item.quantity = item.quantity-total;
    }


    if(this.discountCheck(item.discountPrice)){
       total =  total + (Number(item.discountPrice) * Number(item.quantity));
     }else{
     total =  total + (Number(item.price) * Number(item.quantity));
     }

    item.quantity = item.quantity;

    item.referenceNumber = reference;
    item.locationCode = productLocation;


    var orderDetailDTOs: any = {

       "productsDTO":item,
       "quantity": item.quantity,
       "expectedShipmentDate": expectedShipmentDate,
       "attributeSearch":item.attributeSearch,
     };
     orderProducts.push(orderDetailDTOs);
  }
  STOCKCART.customer.customerJson = "";


  let order = {
    "id":STOCKCART.orderId,
    "barCode":STOCKCART.orderId,
    "orderTitle": this.getOrderTitle(),
    "salesManId":STOCKCART.user.id,
    "orderMessage":STOCKCART.orderMessage,
    "expectedShipmentDate": STOCKCART.expectedShipmentDate,
    "totalAmount":""+total.toFixed(2),
    "totalTexAmount":"10",
    "orderStatus":status,
    "supplierName":supplierName,
    "customerDTO":STOCKCART.customer,
    "orderDetailDTOs": orderProducts,
    "shippingServiceName":STOCKCART.shippingServiceName,
    "shippingServiceValue":STOCKCART.shippingServiceId,
    "supplier" : RECEIVESTOCKLOCATION.supplier
    // "warehouseId" : warehouseId
        };

        return order;

  }

  clearCartProducts(){
    for(let product of STOCKCART.items){
      this.removeAll(product);
    }
    STOCKCART.items = [];
  }

getProductsCount(){
  return STOCKCART.items.length;
}

 getSalesManId(){
   return STOCKCART.user.id;
 }
 getCustomerName(){
   if(STOCKCART.customer !=null){

   return STOCKCART.customer.name;
   }else{
     return null;
   }
 }

 getSalesPerson(){
   return STOCKCART.user;

 }

 getADPCustomerUUID(){
   if(STOCKCART.user && STOCKCART.user.adpCustomerInfo){
   return STOCKCART.user.adpCustomerInfo.uuid;
   }else{
     return "";
   }
 }

 setShipDate(shipDate){
   STOCKCART.expectedShipmentDate = shipDate ;
 }
 // getShipDate(){
 //   return STOCKCART.expectedShipmentDate;
 // }

 // setOdId(odId){
 //   STOCKCART.odId = odId;
 // }

 // getOdId(){
 //   return STOCKCART.odId;
 // }

 // setItems(productsList){
 //   STOCKCART.items = productsList;
 // }
 setOrderId(orderId){
   STOCKCART.orderId = orderId ;
 }
 setOrderMessage(orderMessage){
  STOCKCART.orderMessage = orderMessage;
 }
 // getOrderMessage(){
 //  return STOCKCART.orderMessage;
 // }

 // getExpectedSipDate(){
 //   return STOCKCART.expectedSipDate;
 // }

 getItems(){
   return STOCKCART.items;
 }


 getCustomerID(){
   if(STOCKCART.customer!=null){
     return STOCKCART.customer.id;
   }else{
     return false;
   }
 }


 // getSelectedCustomer(){
 //     return STOCKCART.customer;
 // }

setOrderTitle(orderTitle){
  STOCKCART.orderTitle = orderTitle;
}

getOrderTitle(){
  return STOCKCART.orderTitle;
}
getOrderId(){
  return STOCKCART.orderId;
}

persistOrderLocal(){
 // TODO: Store the list of Cart against their user/sales persons
 let itemQuantityStatus = false;
 for(let product of STOCKCART.items){
   if(product.quantity > 0){
     itemQuantityStatus = true;
     break;
   }
 }

 if(Number(STOCKCART.items.length) > 0 && itemQuantityStatus){
   this.storage.set(this.getADPCustomerUUID()+"-cart-"+this.getSalesManId(),STOCKCART);

 }else{
   this.unPersistOrderLocal();
 }
//this.gVLogger.log(STOCKCART);
}
unPersistOrderLocal(){
  this.storage.remove(this.getADPCustomerUUID()+"-cart-"+this.getSalesManId());


}

// getPersistedOrderLocal(){
//
//   return this.storage.get(this.getADPCustomerUUID()+"-cart-"+this.getSalesManId());
// }

// setCartFull(cartTemp){
//    STOCKCART.items = cartTemp.items;
//    STOCKCART.orderId = cartTemp.orderId;
//    STOCKCART.orderMessage = cartTemp.orderMessage;
//    STOCKCART.customer = cartTemp.customer;
//    STOCKCART.orderTitle = cartTemp.orderTitle;
//   // this.gVLogger.log("Cart Replaced...",cartTemp);
// }


discountCheck(discountPrice){ // if discount price is > 0, return true
    if(Number(discountPrice) > 0){
      return true;
    }else{
      return false;
    }
  }

getOrderStatus(){
  return STOCKCART.orderStatus;
}

setOrderStatus(status){
  STOCKCART.orderStatus = status;
}


// removeJunkFromCart(){
//   for(let item of STOCKCART.items ){
//
//     if(item.quantity == 0 || item.quantity == '0'){
//
//       var index= STOCKCART.items.map(function(x) {return x.id; }).indexOf(item.id);
//       if (index != -1) {
//           if(STOCKCART.items[index].quantity >= 1){
//             STOCKCART.items[index].quantity = 0;
//           }
//           STOCKCART.items.splice(index, 1);
//         }
//     }
//   }
// }


makeImageURL(dimensions,item){
  return  IMAGES_BASE_URL.imageBaseUrl + "/" + this.getADPCustomerUUID() +
  "/products/" +
  dimensions + "/"+
  item.productImagesDTO[0].name+
  "-" +
   dimensions +
   "." +
   item.productImagesDTO[0].extension;
}


// setShipingServiceName(name){
//   STOCKCART.shippingServiceName = name;
// }
// getShippingServiceName(){
//   return STOCKCART.shippingServiceName;
// }

// setShippingServiceId(id){
//   STOCKCART.shippingServiceId = id;
// }
// getShippingServiceId(){
// return STOCKCART.shippingServiceId;
// }


// setAdpCustomerInfo(adpCustomerInfo){
//   AdpCustomer.AdpCustomerInfo = adpCustomerInfo;
// }

getAdpCustomerInfo(){
  return AdpCustomer.AdpCustomerInfo;
}


// sanitizeUrl(url){
//   return this.sanitizer.bypassSecurityTrustResourceUrl(url);
//   }
//
//
//
//   addToAttributeMap(key,value){
//     attributesMap[key+""] = ""+value;
//   }

  getAttributeValue(key){
    let res = attributesMap[key+""];
    if(res === undefined){
      return "-"
    }else{
      return res;
    }
  }


  // addAttributePropertiesMap(key,val){
  //   attributesPropertiesMap.set(key+"", val);
  // }
  //
  // getAllAttributesPropertiesMap(){
  //   return attributesPropertiesMap;
  // }

  replaceDoublePipe(str){
    return str.split("||").join(" ");
  }

  ConvertToCSV(objArray) {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row = "";
    for (let index in objArray[0]) {
        //Now convert each value to string and comma-separated
        row += index + ',';
    }
    row = row.slice(0, -1);
    //append Label row with line break
    str += row + '\r\n';

    for (let i = 0; i < array.length; i++) {
        let line = '';
        for (let index in array[i]) {
            if (line != '') line += ',';
            line += array[i][index];
        }
        str += line + '\r\n';
    }
    return str;
  }
}



// WEBPACK FOOTER //
// ./src/providers/stockcart-manager.ts